import { JSX } from 'preact'
import { useMemo } from 'preact/hooks'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { previewProps } from '../../preview'
import { useComponentStyle } from '../Style'
import { applyMatchedMedia, getAllMediaQueries } from '../Style/media'
import { useMediaQueries } from '../useMediaQueries'

const atMedia = (query: string): string => {
  return query.startsWith('@media') ? query : `@media ${query}`
}

export const Image = (props: TBlockProps<BlockType.Image>): JSX.Element => {
  const { classes } = useComponentStyle('image', props)

  const { id, src: defaultSrc, sources, css } = props

  const queries = useMemo(() => {
    const fromSources = sources?.map(s => atMedia(s.media)) ?? []
    const fromCss = getAllMediaQueries(css ?? {})
    return [...new Set([...fromSources, ...fromCss])]
  }, [css, sources])

  const matches = useMediaQueries(queries)

  const visible = useMemo(() => {
    return applyMatchedMedia(css ?? {}, matches)?.display !== 'none'
  }, [css, matches])
  const src = sources?.find(s => matches[atMedia(s.media)])?.srcSet || defaultSrc

  return visible ? <img src={src} className={classnames(classes)} {...previewProps(BlockType.Image, id, true)} /> : null
}
